import { createSelector } from 'reselect';
import { isMessage } from 'helpers/intl-fns';

const snackbarSelector = state => state.snackbar;

const selectSnackbar = createSelector(snackbarSelector, snackbar => snackbar || {});

export const selectSnackbarInfo = createSelector(selectSnackbar, state => {
  const {
    type = 'success',
    message = null,
    values = {},
    registeredSnackbars = [],
    icon,
    isLowStyle,
    description,
  } = state;
  return {
    type,
    icon,
    isLowStyle,
    targetId: registeredSnackbars[0],
    messageProps: isMessage(message) ? { ...message, values } : message,
    description,
  };
});
